import { Box, Card, Skeleton, Text } from '@factorialco/deprecated-design-system'
import {
  AtsEntitiesInsightsJobPostingsInsightIdEnum,
  AtsJobPostingsInsightsStateChartFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  data: Record<
    AtsEntitiesInsightsJobPostingsInsightIdEnum,
    AtsJobPostingsInsightsStateChartFragment
  >
}

export const JobPostingsStateChart = ({ data }: Props) => {
  const metrics = [
    {
      label: i18n.t('ats.insights_page.main_metrics.job_openings_state.metrics.new_job_openings'),
      count: data.new_job_postings.count,
    },
    {
      label: i18n.t('ats.insights_page.main_metrics.job_openings_state.metrics.total_open_jobs'),
      count: data.job_postings.count,
    },
    {
      label: i18n.t(
        'ats.insights_page.main_metrics.job_openings_state.metrics.jobs_with_hired_candidates'
      ),
      count: data.job_postings_with_hiring.count,
    },
  ]

  return (
    <Card>
      <Card.Title tooltip={i18n.t('ats.insights_page.main_metrics.job_openings_state.info')}>
        {i18n.t('ats.insights_page.main_metrics.job_openings_state.title')}
      </Card.Title>
      <Card.Content>
        <Box flexDirection="row" gap="s16" justifyContent="spaceBetween" width="full">
          {metrics.map((entry) => (
            <Box key={entry.label} gap="s4">
              <Text.Normal>{entry.label}</Text.Normal>
              {entry.count !== undefined ? (
                <Text size="700" weight="medium" color="grey1000">
                  {entry.count}
                </Text>
              ) : (
                <Box height="s48" justifyContent="center">
                  <Skeleton width="s80" height="s16" />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Card.Content>
    </Card>
  )
}
